<script setup>
import useInventoryTable from "./hooks/useInventoryTable";
import Adjust from "./adjust.vue";
import { onMounted } from "vue";
import useCateGoryList from "../../hooks/useCategoryList";
import useStashList from "../../hooks/useStashList";
import useDict from "../../hooks/useDict";

const { categoryList } = useCateGoryList();
const { stashList } = useStashList();
const { result } = useDict();

const defaultProps = {
  label: "node",
  disabled: (data) => {
    return data.parentId == "0";
  },
};

const isActive = (row) => {
  if (row.totalQuantity < row.lowerLimit || row.totalQuantity > row.upperLimit)
    return true;
  return false;
};

const {
  searchRef,
  searchData,
  columns,
  tableData,
  tableLoading,
  pages,
  editRef,
  getList,
  handleReset,
  handleAdjust,
  handleExport,
} = useInventoryTable();

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '库存管理' }">
    <template #header-btn></template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="物料名称：" prop="name">
              <el-input v-model="searchData.name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物料编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物料类别：" prop="categoryId">
              <el-tree-select
                v-model="searchData.categoryId"
                :data="categoryList"
                :render-after-expand="false"
                show-checkbox
                :props="defaultProps"
                :check-strictly="true"
                node-key="id"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="品牌：" prop="brand">
              <el-select
                v-model="searchData.brand"
                placeholder="请输入"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in result.brand"
                  :key="item.id"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="规格型号：" prop="model">
              <el-select
                v-model="searchData.model"
                placeholder="请输入"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in result.model"
                  :key="item.id"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="仓库：" prop="warehouseId">
              <el-select
                v-model="searchData.warehouseId"
                placeholder="请输入"
                style="width: 100%"
              >
                <el-option
                  v-for="item in stashList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :sm="12">
            <el-form-item label="库存数量：">
              <div style="display: flex">
                <el-input-number
                  :controls="false"
                  v-model="searchData.lowerQuantity"
                  placeholder="最小值"
                ></el-input-number>
                <span>-</span>
                <el-input-number
                  :controls="false"
                  v-model="searchData.upperQuantity"
                  placeholder="最大值"
                ></el-input-number>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-button icon="Download" @click="handleExport()">导出</el-button>
      <el-button type="primary" icon="Search" @click="getList()"
        >查询</el-button
      >
      <el-button icon="Refresh" @click="handleReset()">重置</el-button>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{
          'text-align': 'center',
        }"
        style="width: 100%; margin-top: 10px"
        max-height="650"
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column label="序号" type="index" width="55" fixed />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
            :min-width="120"
          >
            <template #default="{ row }">
              <span
                v-if="item.prop == 'totalQuantity'"
                :class="{ active: isActive(row) }"
              >
                {{ row[item.prop] ?? "-" }}
              </span>
              <span
                v-else-if="
                  ['lockInventory', 'upperLimit', 'lowerLimit'].includes(
                    item.prop
                  )
                "
                >{{ row[item.prop] ?? "-" }}</span
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="库存总价" width="200">
          <template #default="{ row }">
            <span>{{ row.totalCost }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 'detail')"
              >详情</el-button
            >
            <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >库存预警设置</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        :total="pages.total"
        layout="->, prev, pager, next"
        class="mt10"
        v-model:current-page="pages.page"
        @update:current-page="getList"
      />
    </template>
  </zh-table-page>
  <Adjust ref="editRef" @after-save="getList" />
</template>

<style scoped>
.active {
  color: #f56c6c;
}
</style>
